import { apiService } from '../core/ApiService.js';
import { toast } from './Toast.js';
import { i18n } from '../utils/I18n.js';

export class ProfileModal {
    constructor(onUpdate) {
        this.container = null;
        this.onUpdate = onUpdate;
        this.currentTab = 'profile';
        this.newAvatarBase64 = null;
    }

    create() {
        if (document.getElementById('profileModal')) return;

        const modal = document.createElement('div');
        modal.id = 'profileModal';
        modal.innerHTML = `
            <div class="pf-modal-content">
                <button class="pf-close-btn">&times;</button>
                <h2 class="pf-title" data-i18n="profile.title">Profile Settings</h2>
                
                <div class="pf-tabs">
                    <button class="pf-tab active" data-tab="profile" data-i18n="profile.tab_general">General</button>
                    <button class="pf-tab" data-tab="security" data-i18n="profile.tab_security">Security</button>
                </div>

                <div class="pf-body">
                    <!-- General Tab -->
                    <div id="pf-tab-profile" class="pf-tab-content">
                        <div class="pf-avatar-section">
                            <div class="pf-avatar-wrapper">
                                <img id="pfAvatarPreview" src="" alt="Avatar" referrerpolicy="no-referrer">
                                <div class="pf-avatar-overlay">
                                    <svg viewBox="0 0 24 24" width="24" height="24" fill="white"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/></svg>
                                </div>
                                <input type="file" id="pfAvatarInput" accept="image/*" style="display:none">
                            </div>
                            <div class="pf-avatar-hint" data-i18n="profile.avatar_hint">Click to upload (Auto-resized to &lt;100KB)</div>
                        </div>
                        
                        <div class="form-group">
                            <label data-i18n="profile.username_label">Username</label>
                            <input type="text" id="pfUsername" data-i18n="profile.username_placeholder" placeholder="Enter new username">
                        </div>
                        
                        <button id="pfSaveProfile" class="pf-btn-primary" data-i18n="profile.save_btn">Save Changes</button>
                    </div>

                    <!-- Security Tab -->
                    <div id="pf-tab-security" class="pf-tab-content" style="display:none">
                        <div id="pfGoogleHint" style="display:none; text-align:center; color:#8B7355; background:#FDF6EC; padding:20px; border-radius:12px; margin-bottom:10px;">
                            <div style="font-size:32px; margin-bottom:10px;">🔒</div>
                            <div style="font-weight:600; margin-bottom:5px;" data-i18n="profile.google_account">Google Login Account</div>
                            <div style="font-size:0.9rem; opacity:0.8;" data-i18n="profile.google_hint">Password management is handled by Google.</div>
                        </div>
                        
                        <div id="pfPasswordForm">
                            <div class="form-group">
                                <label data-i18n="profile.old_pass_label">Current Password</label>
                                <input type="password" id="pfOldPass" data-i18n="profile.old_pass_placeholder" placeholder="Current password">
                            </div>
                            <div class="form-group">
                                <label data-i18n="profile.new_pass_label">New Password</label>
                                <input type="password" id="pfNewPass" data-i18n="profile.new_pass_placeholder" placeholder="New password">
                            </div>
                            <div class="form-group">
                                <label data-i18n="profile.confirm_pass_label">Confirm New Password</label>
                                <input type="password" id="pfConfirmPass" data-i18n="profile.confirm_pass_placeholder" placeholder="Confirm new password">
                            </div>
                            
                            <button id="pfChangePass" class="pf-btn-primary" data-i18n="profile.update_pass_btn">Update Password</button>
                        </div>
                    </div>
                </div>
            </div>
        `;

        this._injectStyles();
        document.body.appendChild(modal);
        this.container = modal;

        this._bindEvents();
    }

    _injectStyles() {
        if (document.getElementById('pf-modal-styles')) return;
        const style = document.createElement('style');
        style.id = 'pf-modal-styles';
        style.textContent = `
            #profileModal {
                position: fixed;
                top: 0; left: 0; width: 100%; height: 100%;
                background: rgba(0, 0, 0, 0.6);
                backdrop-filter: blur(5px);
                z-index: 3000;
                display: none;
                align-items: center;
                justify-content: center;
                opacity: 0;
                transition: opacity 0.3s ease;
            }
            #profileModal.visible { opacity: 1; }
            .pf-modal-content {
                background: #FFFFFF;
                width: 90%;
                max-width: 450px;
                border-radius: 20px;
                padding: 30px;
                position: relative;
                box-shadow: 0 10px 40px rgba(0,0,0,0.2);
                transform: translateY(20px);
                transition: transform 0.3s;
            }
            #profileModal.visible .pf-modal-content { transform: translateY(0); }
            
            .pf-close-btn {
                position: absolute; top: 15px; right: 15px;
                background: none; border: none; font-size: 24px; color: #888; cursor: pointer;
            }
            .pf-title { text-align: center; color: #5D4E42; margin-bottom: 20px; font-size: 1.5rem; }
            
            .pf-tabs { display: flex; border-bottom: 1px solid #EEE; margin-bottom: 24px; }
            .pf-tab {
                flex: 1; padding: 12px; background: none; border: none;
                font-size: 1rem; font-weight: 600; color: #BBB;
                cursor: pointer; border-bottom: 2px solid transparent; transition: all 0.3s;
            }
            .pf-tab.active { color: #A67C52; border-bottom-color: #A67C52; }
            
            .pf-avatar-section { display: flex; flex-direction: column; align-items: center; margin-bottom: 24px; }
            .pf-avatar-wrapper {
                width: 100px; height: 100px; position: relative; border-radius: 50%;
                overflow: hidden; cursor: pointer; border: 3px solid #FDF6EC;
                box-shadow: 0 4px 12px rgba(0,0,0,0.1);
            }
            .pf-avatar-wrapper img { width: 100%; height: 100%; object-fit: cover; }
            .pf-avatar-overlay {
                position: absolute; inset: 0; background: rgba(0,0,0,0.3);
                display: flex; align-items: center; justify-content: center;
                opacity: 0; transition: opacity 0.2s;
            }
            .pf-avatar-wrapper:hover .pf-avatar-overlay { opacity: 1; }
            .pf-avatar-hint { font-size: 0.8rem; color: #999; margin-top: 8px; }
            
            .form-group { margin-bottom: 16px; }
            .form-group label { display: block; font-size: 0.9rem; color: #555; margin-bottom: 6px; font-weight: 500; }
            .form-group input {
                width: 100%; padding: 10px 14px; border: 1px solid #DDD;
                border-radius: 8px; font-size: 1rem; outline: none; transition: border-color 0.3s;
            }
            .form-group input:focus { border-color: #C9A77D; }
            
            .pf-btn-primary {
                width: 100%; padding: 12px; background: linear-gradient(135deg, #C9A77D, #A67C52);
                color: white; border: none; border-radius: 8px; font-size: 1rem; font-weight: 600;
                cursor: pointer; transition: opacity 0.3s; margin-top: 10px;
            }
            .pf-btn-primary:hover { opacity: 0.9; }
        `;
        document.head.appendChild(style);
    }

    _bindEvents() {
        this.container.querySelector('.pf-close-btn').onclick = () => this.hide();

        const tabs = this.container.querySelectorAll('.pf-tab');
        tabs.forEach(tab => {
            tab.onclick = () => {
                tabs.forEach(t => t.classList.remove('active'));
                tab.classList.add('active');
                
                document.getElementById('pf-tab-profile').style.display = tab.dataset.tab === 'profile' ? 'block' : 'none';
                document.getElementById('pf-tab-security').style.display = tab.dataset.tab === 'security' ? 'block' : 'none';
            };
        });

        const avatarWrapper = this.container.querySelector('.pf-avatar-wrapper');
        const avatarInput = document.getElementById('pfAvatarInput');
        
        avatarWrapper.onclick = () => {
            avatarInput.value = ''; // Reset value to allow re-selecting same file
            avatarInput.click();
        };
        
        avatarInput.onchange = async (e) => {
            const file = e.target.files[0];
            if (!file) return;
            
            // Allow larger initial files (e.g. 5MB) because we compress them
            if (file.size > 5 * 1024 * 1024) { 
                toast.error(i18n.t('profile.img_large'));
                return;
            }
            
            try {
                // Compress image
                const compressedBase64 = await this.compressImage(file);
                
                // Check compressed size (limit 150000 chars ~ 110KB)
                if (compressedBase64.length > 150000) {
                    toast.error(i18n.t('profile.img_complex'));
                    return;
                }

                this.newAvatarBase64 = compressedBase64;
                document.getElementById('pfAvatarPreview').src = this.newAvatarBase64;
                // toast.success('Image processed successfully!');
            } catch (err) {
                console.error(err);
                toast.error(i18n.t('profile.img_process_fail'));
            }
        };

        document.getElementById('pfSaveProfile').onclick = async () => {
            const username = document.getElementById('pfUsername').value;
            if (!this.newAvatarBase64 && (!username || username === this.initialUser.username)) {
                toast.info(i18n.t('profile.no_changes'));
                return;
            }
            
            try {
                const updatedUser = await apiService.updateProfile(username, this.newAvatarBase64);
                if (updatedUser) {
                    if (this.onUpdate) this.onUpdate(updatedUser);
                    this.hide();
                }
            } catch (e) {
                // handled by apiService
            }
        };

        document.getElementById('pfChangePass').onclick = async () => {
            const oldPass = document.getElementById('pfOldPass').value;
            const newPass = document.getElementById('pfNewPass').value;
            const confirmPass = document.getElementById('pfConfirmPass').value;
            
            if (newPass !== confirmPass) {
                toast.error(i18n.t('profile.pass_mismatch'));
                return;
            }
            
            try {
                await apiService.changePassword(oldPass, newPass);
                document.getElementById('pfOldPass').value = '';
                document.getElementById('pfNewPass').value = '';
                document.getElementById('pfConfirmPass').value = '';
                this.hide();
            } catch (e) {
                // handled by apiService
            }
        };
    }

    compressImage(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    // Resize to 256x256 max
                    const MAX_WIDTH = 256;
                    const MAX_HEIGHT = 256;
                    let width = img.width;
                    let height = img.height;

                    if (width > height) {
                        if (width > MAX_WIDTH) {
                            height *= MAX_WIDTH / width;
                            width = MAX_WIDTH;
                        }
                    } else {
                        if (height > MAX_HEIGHT) {
                            width *= MAX_HEIGHT / height;
                            height = MAX_HEIGHT;
                        }
                    }
                    
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);
                    
                    // Export as JPEG with 0.8 quality
                    // This typically results in 10-30KB files
                    const dataUrl = canvas.toDataURL('image/jpeg', 0.8);
                    resolve(dataUrl);
                };
                img.onerror = (err) => reject(err);
            };
            reader.onerror = (err) => reject(err);
        });
    }

    show() {
        if (!this.container) this.create();
        
        const user = apiService.getCurrentUser();
        if (!user) return;
        
        this.initialUser = user;
        this.newAvatarBase64 = null;

        document.getElementById('pfUsername').value = user.username;
        document.getElementById('pfAvatarPreview').src = user.avatar_url || `https://ui-avatars.com/api/?name=${user.username}&background=random`;
        
        if (user.has_password === false) {
             document.getElementById('pfGoogleHint').style.display = 'block';
             document.getElementById('pfPasswordForm').style.display = 'none';
        } else {
             document.getElementById('pfGoogleHint').style.display = 'none';
             document.getElementById('pfPasswordForm').style.display = 'block';
        }

        document.getElementById('pfOldPass').value = '';
        document.getElementById('pfNewPass').value = '';
        document.getElementById('pfConfirmPass').value = '';

        this.container.style.display = 'flex';
        this.container.offsetHeight;
        this.container.classList.add('visible');

        i18n.applyTranslations();
    }

    hide() {
        if (!this.container) return;
        this.container.classList.remove('visible');
        setTimeout(() => {
            this.container.style.display = 'none';
        }, 300);
    }
}
